import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faMapMarkerAlt,
  faPhone,
  faEnvelope,
  faStar,
} from "@fortawesome/free-solid-svg-icons";

export default function MahilaMandiWholesaleSupply() {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [pinCode, setPinCode] = useState("");
  const [filterApplied, setFilterApplied] = useState(false);
  const [showSupplierDetails, setShowSupplierDetails] = useState(null);
  const [sortBy, setSortBy] = useState("relevance"); // relevance, rating, priceLow, priceHigh

  const categories = [
    { name: "Pickles & Preserves Ingredients", img: "🥒" },
    { name: "Handmade Soaps Ingredients", img: "🧼" },
    { name: "Baked Goods Ingredients", img: "🍪" },
    { name: "Herbal Teas Ingredients", img: "☕" },
    { name: "Textiles Ingredients", img: "🧵" },
    { name: "Jewelry Ingredients", img: "💍" },
    { name: "Candles Ingredients", img: "🕯️" },
    { name: "Pottery Ingredients", img: "🏺" },
    { name: "Handicrafts Ingredients", img: "🪡" },
  ];

  // ✅ Only one dummy category for now, others can be extended later
  const dummyItems = {
    "Pickles & Preserves Ingredients": [
      {
        name: "Raw Mango (Bulk 20kg)",
        brief:
          "Fresh seasonal raw mangoes for pickling, sourced from local farms for women cooperatives.",
        priceRange: "₹800 - ₹1,000",
        img: "https://via.placeholder.com/150x100/FF6B6B/FFFFFF?text=Raw+Mango",
        supplier: {
          name: "GreenHarvest Farms",
          phone: "+91-98765-43210",
          email: "supply@greenharvest.in",
          location: "Nashik, Maharashtra",
          rating: 4.7,
          numReviews: 145,
          reviewSnippet: "Reliable supplier with fresh produce. Fast delivery!",
        },
      },
      {
        name: "Glass Jars (200ml, Pack of 100)",
        brief:
          "Sterilized glass jars for packaging homemade pickles, durable and eco-friendly.",
        priceRange: "₹800 - ₹1,000",
        img: "https://via.placeholder.com/150x100/E74C3C/FFFFFF?text=Glass+Jars",
        supplier: {
          name: "EcoPack Glassworks",
          phone: "+91-54321-09876",
          email: "orders@ecopack.in",
          location: "Firozabad, UP",
          rating: 4.4,
          numReviews: 67,
          reviewSnippet: "Affordable and reliable packaging solutions.",
        },
      },
    ],

    "Handmade Soaps Ingredients": [
      {
        name: "Soap Molds (Silicone, 6-Cavity)",
        brief:
          "Reusable silicone molds ideal for small-batch handmade soap production.",
        priceRange: "₹500 - ₹750",
        img: "https://via.placeholder.com/150x100/8E44AD/FFFFFF?text=Soap+Molds",
        supplier: {
          name: "CraftEase Supplies",
          phone: "+91-99876-54321",
          email: "sales@craftease.in",
          location: "Pune, Maharashtra",
          rating: 4.6,
          numReviews: 120,
          reviewSnippet: "Durable molds and fast shipping.",
        },
      },
      {
        name: "Kraft Soap Boxes (100 pcs)",
        brief:
          "Eco-friendly kraft boxes for handmade soaps, customizable with branding.",
        priceRange: "₹1,200 - ₹1,500",
        img: "https://via.placeholder.com/150x100/D35400/FFFFFF?text=Soap+Boxes",
        supplier: {
          name: "PackNaturals",
          phone: "+91-77889-22334",
          email: "info@packnaturals.in",
          location: "Mumbai, Maharashtra",
          rating: 4.8,
          numReviews: 200,
          reviewSnippet: "High-quality packaging and print options.",
        },
      },
    ],

    "Baked Goods Ingredients": [
      {
        name: "Cupcake Paper Liners (Pack of 500)",
        brief: "Heat-resistant paper liners for cupcakes and muffins.",
        priceRange: "₹400 - ₹600",
        img: "https://via.placeholder.com/150x100/F1C40F/000000?text=Cupcake+Liners",
        supplier: {
          name: "BakePack Supplies",
          phone: "+91-90909-80808",
          email: "order@bakepack.in",
          location: "Nagpur, Maharashtra",
          rating: 4.5,
          numReviews: 85,
          reviewSnippet: "Colorful liners at great prices.",
        },
      },
      {
        name: "Cake Boxes (12x12x6 inch, 50 pcs)",
        brief: "Food-grade boxes for bakery packaging with viewing window.",
        priceRange: "₹1,000 - ₹1,300",
        img: "https://via.placeholder.com/150x100/1ABC9C/FFFFFF?text=Cake+Boxes",
        supplier: {
          name: "FoodWrap Co.",
          phone: "+91-81234-56789",
          email: "contact@foodwrap.in",
          location: "Kolhapur, Maharashtra",
          rating: 4.7,
          numReviews: 110,
          reviewSnippet: "Excellent quality bakery packaging.",
        },
      },
    ],

    "Herbal Teas Ingredients": [
      {
        name: "Zip-Lock Kraft Pouches (500g x 100)",
        brief:
          "Eco-friendly resealable pouches for herbal teas and powdered mixes.",
        priceRange: "₹900 - ₹1,200",
        img: "https://via.placeholder.com/150x100/27AE60/FFFFFF?text=Kraft+Pouches",
        supplier: {
          name: "NaturePack Solutions",
          phone: "+91-88822-33445",
          email: "orders@naturepack.in",
          location: "Nashik, Maharashtra",
          rating: 4.6,
          numReviews: 92,
          reviewSnippet: "Perfect for tea blends and organic products.",
        },
      },
      {
        name: "Tin Containers (100g, Pack of 50)",
        brief:
          "Airtight tin containers for premium tea packaging with printed labels.",
        priceRange: "₹1,500 - ₹1,800",
        img: "https://via.placeholder.com/150x100/16A085/FFFFFF?text=Tin+Containers",
        supplier: {
          name: "EcoTin India",
          phone: "+91-70333-55677",
          email: "sales@ecotin.in",
          location: "Thane, Maharashtra",
          rating: 4.9,
          numReviews: 180,
          reviewSnippet: "High-quality metallic packaging.",
        },
      },
    ],

    "Textiles Ingredients": [
      {
        name: "Fabric Rolls (Cotton, 50m)",
        brief:
          "Pre-washed cotton rolls for handloom and textile craft units.",
        priceRange: "₹2,500 - ₹3,000",
        img: "https://via.placeholder.com/150x100/2980B9/FFFFFF?text=Fabric+Rolls",
        supplier: {
          name: "MahaTextile Co-op",
          phone: "+91-90210-55667",
          email: "info@mahatextile.in",
          location: "Solapur, Maharashtra",
          rating: 4.5,
          numReviews: 140,
          reviewSnippet: "Affordable bulk fabric supplies.",
        },
      },
      {
        name: "Poly Mailer Bags (100 pcs)",
        brief:
          "Durable poly mailer bags for shipping textile and apparel products.",
        priceRange: "₹700 - ₹900",
        img: "https://via.placeholder.com/150x100/2471A3/FFFFFF?text=Mailer+Bags",
        supplier: {
          name: "WrapSmart India",
          phone: "+91-76543-21100",
          email: "support@wrapsmart.in",
          location: "Pune, Maharashtra",
          rating: 4.7,
          numReviews: 160,
          reviewSnippet: "Strong, tamper-proof packaging.",
        },
      },
    ],

    "Jewelry Ingredients": [
      {
        name: "Jewelry Boxes (Velvet, Pack of 50)",
        brief: "Luxury velvet jewelry boxes with transparent lids.",
        priceRange: "₹2,000 - ₹2,500",
        img: "https://via.placeholder.com/150x100/9B59B6/FFFFFF?text=Jewelry+Boxes",
        supplier: {
          name: "ShreePack India",
          phone: "+91-88990-11223",
          email: "sales@shreepack.in",
          location: "Mumbai, Maharashtra",
          rating: 4.8,
          numReviews: 175,
          reviewSnippet: "Beautiful designs, sturdy build.",
        },
      },
      {
        name: "Plastic Zip Bags (2x2 inch, 500 pcs)",
        brief:
          "Transparent zip bags for storing earrings, rings, and small jewelry pieces.",
        priceRange: "₹400 - ₹600",
        img: "https://via.placeholder.com/150x100/AF7AC5/FFFFFF?text=Zip+Bags",
        supplier: {
          name: "ClearPack Solutions",
          phone: "+91-77788-99890",
          email: "order@clearpack.in",
          location: "Vasai, Maharashtra",
          rating: 4.4,
          numReviews: 120,
          reviewSnippet: "Simple and affordable jewelry packaging.",
        },
      },
    ],

    "Candles Ingredients": [
      {
        name: "Glass Candle Jars (250ml, 50 pcs)",
        brief:
          "Heat-resistant glass jars for scented candle production with lids.",
        priceRange: "₹1,200 - ₹1,500",
        img: "https://via.placeholder.com/150x100/F39C12/FFFFFF?text=Candle+Jars",
        supplier: {
          name: "LightCraft India",
          phone: "+91-80980-12345",
          email: "sales@lightcraft.in",
          location: "Aurangabad, Maharashtra",
          rating: 4.7,
          numReviews: 155,
          reviewSnippet: "Excellent quality and packaging.",
        },
      },
      {
        name: "Candle Tin Containers (100ml, 100 pcs)",
        brief:
          "Aluminium tins with lids for travel candles and gifting sets.",
        priceRange: "₹1,000 - ₹1,300",
        img: "https://via.placeholder.com/150x100/F5B041/FFFFFF?text=Candle+Tins",
        supplier: {
          name: "GlowPack Supplies",
          phone: "+91-81990-98765",
          email: "info@glowpack.in",
          location: "Nagpur, Maharashtra",
          rating: 4.5,
          numReviews: 130,
          reviewSnippet: "Perfect tins for home-based candle businesses.",
        },
      },
    ],

    "Pottery Ingredients": [
      {
        name: "Clay Packaging Boxes (100 pcs)",
        brief:
          "Corrugated boxes for safe transport of pottery and ceramic products.",
        priceRange: "₹1,000 - ₹1,300",
        img: "https://via.placeholder.com/150x100/BA4A00/FFFFFF?text=Clay+Boxes",
        supplier: {
          name: "SafeShip Packaging",
          phone: "+91-82110-99887",
          email: "sales@safeship.in",
          location: "Kolhapur, Maharashtra",
          rating: 4.6,
          numReviews: 95,
          reviewSnippet: "Strong and reliable packaging.",
        },
      },
      {
        name: "Bubble Wrap Rolls (100m)",
        brief: "Protective bubble wrap rolls for pottery and fragile products.",
        priceRange: "₹700 - ₹900",
        img: "https://via.placeholder.com/150x100/D68910/FFFFFF?text=Bubble+Wrap",
        supplier: {
          name: "WrapSecure India",
          phone: "+91-76650-34567",
          email: "info@wrapsecure.in",
          location: "Mumbai, Maharashtra",
          rating: 4.7,
          numReviews: 88,
          reviewSnippet: "Great cushioning for shipping ceramics.",
        },
      },
    ],

    "Handicrafts Ingredients": [
      {
        name: "Corrugated Boxes (Small, 100 pcs)",
        brief:
          "Compact boxes ideal for handicrafts, wooden toys, and artisan goods.",
        priceRange: "₹1,000 - ₹1,200",
        img: "https://via.placeholder.com/150x100/7D6608/FFFFFF?text=Craft+Boxes",
        supplier: {
          name: "CraftPack India",
          phone: "+91-91122-33445",
          email: "hello@craftpack.in",
          location: "Nashik, Maharashtra",
          rating: 4.8,
          numReviews: 140,
          reviewSnippet: "Perfect fit for handmade product packaging.",
        },
      },
      {
        name: "Jute Bags (Medium, Pack of 50)",
        brief:
          "Eco-friendly jute bags for handicraft gifting and artisan packaging.",
        priceRange: "₹1,200 - ₹1,500",
        img: "https://via.placeholder.com/150x100/CA6F1E/FFFFFF?text=Jute+Bags",
        supplier: {
          name: "EcoBag Enterprises",
          phone: "+91-90321-44556",
          email: "orders@ecobag.in",
          location: "Sangli, Maharashtra",
          rating: 4.9,
          numReviews: 190,
          reviewSnippet: "Strong and sustainable packaging option.",
        },
      },
    ],
  };


  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setFilterApplied(true);
  };

  // ✅ Prevent undefined error
  const filteredItems = selectedCategory && dummyItems[selectedCategory] ? dummyItems[selectedCategory] : [];

  const searchFilteredItems = filteredItems.filter(
    (item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.brief.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleShowSupplier = (item) => setShowSupplierDetails(item.supplier);
  const handleHideSupplier = () => setShowSupplierDetails(null);

  // ✅ Safe star rendering
  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    return Array.from({ length: 5 }, (_, i) => (
      <FontAwesomeIcon
        key={i}
        icon={faStar}
        className={i < fullStars ? "text-yellow-400" : "text-gray-500"}
      />
    ));
  };

  const sortItems = (items, sortBy) => {
    switch (sortBy) {
      case "rating":
        return [...items].sort(
          (a, b) => b.supplier.rating - a.supplier.rating
        );
      case "priceLow":
        return [...items].sort((a, b) => {
          const aNum = parseFloat(
            a.priceRange.split("-")[0].replace(/[₹\s]/g, "")
          );
          const bNum = parseFloat(
            b.priceRange.split("-")[0].replace(/[₹\s]/g, "")
          );
          return aNum - bNum;
        });
      case "priceHigh":
        return [...items].sort((a, b) => {
          const aNum = parseFloat(
            a.priceRange.split("-")[0].replace(/[₹\s]/g, "")
          );
          const bNum = parseFloat(
            b.priceRange.split("-")[0].replace(/[₹\s]/g, "")
          );
          return bNum - aNum;
        });
      default:
        return items;
    }
  };

  const sortedItems = sortItems(searchFilteredItems, sortBy);

  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      {/* Header */}
      <header className="bg-green-800 p-4 shadow-md">
        <h1 className="text-xl md:text-2xl font-bold text-center">
          MahilaMandi Wholesale Supply - Ingredients Catalogue
        </h1>
        <p className="text-center text-sm mt-2">
          Wholesale raw materials & ingredients for Women Udyog enterprises -
          Bulk sourcing for production
        </p>
      </header>

      {/* Search Bar */}
      <div className="p-4 bg-black border-b border-green-500">
        <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faMapMarkerAlt} className="text-green-400" />
            <input
              type="text"
              value={pinCode}
              onChange={(e) => setPinCode(e.target.value)}
              placeholder="Enter PIN Code for Local Sourcing"
              className="px-4 py-2 rounded-md bg-gray-800 text-white w-full md:w-48"
            />
          </div>
          <div className="relative w-full md:w-96">
            <FontAwesomeIcon
              icon={faSearch}
              className="absolute left-3 top-3 text-green-400"
            />
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search ingredients, descriptions, or keywords..."
              className="w-full pl-10 pr-4 py-2 rounded-md bg-gray-800 text-white"
            />
          </div>
        </div>
      </div>

      {/* Main Content */}
      <main className="flex-1 p-6">
        <div className="mb-6">
          <h2 className="text-lg font-semibold mb-2">
            Browse Ingredient Categories
          </h2>
          <p className="text-sm text-gray-300">
            Click a category to view wholesale ingredients suitable for
            women-led Udyog production.
          </p>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
          {categories.map((cat) => (
            <div
              key={cat.name}
              onClick={() => handleCategoryClick(cat.name)}
              className={`p-4 rounded-lg cursor-pointer transition-all ${
                selectedCategory === cat.name
                  ? "bg-green-700 border-2 border-green-400 shadow-lg"
                  : "bg-gray-800 hover:bg-gray-700"
              }`}
            >
              <div className="text-4xl mb-3 text-center">{cat.img}</div>
              <h3 className="text-sm font-medium text-center">{cat.name}</h3>
            </div>
          ))}
        </div>

        {/* Items */}
        {filterApplied && selectedCategory && (
          <section>
            <div className="flex flex-col md:flex-row justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">
                Ingredients for {selectedCategory}
              </h2>
              <div className="flex items-center gap-2 mt-2 md:mt-0">
                <label className="text-sm">Sort by:</label>
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="px-2 py-1 rounded-md bg-gray-800 text-white"
                >
                  <option value="relevance">Relevance</option>
                  <option value="rating">Supplier Rating</option>
                  <option value="priceLow">Price: Low → High</option>
                  <option value="priceHigh">Price: High → Low</option>
                </select>
              </div>
            </div>

            <p className="text-sm text-gray-300 mb-4">
              {sortedItems.length} items matching "{searchTerm}". These wholesale
              ingredients are ideal for bulk production in MahilaMandi Udyog.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {sortedItems.map((item, index) => (
                <div
                  key={index}
                  className="bg-gray-800 p-4 rounded-lg shadow-md hover:shadow-lg transition-shadow"
                >
                  <img
                    src={item.img}
                    alt={item.name}
                    className="w-full h-48 object-cover rounded-md mb-3"
                  />
                  <h3 className="text-md font-semibold mb-1">{item.name}</h3>
                  <p className="text-sm text-gray-300 mb-2">{item.brief}</p>
                  <p className="text-green-400 font-bold mb-3">
                    {item.priceRange}
                  </p>
                  <button
                    onClick={() => handleShowSupplier(item)}
                    className="w-full mb-2 bg-green-600 hover:bg-green-700 text-white py-2 rounded-md"
                  >
                    Contact Supplier
                  </button>
                  <div className="flex items-center justify-between text-sm">
                    <div className="flex items-center">
                      {renderStars(item.supplier.rating)}
                      <span className="ml-1 text-gray-400">
                        ({item.supplier.numReviews})
                      </span>
                    </div>
                    <p className="italic text-xs text-gray-400 truncate max-w-[120px]">
                      {item.supplier.reviewSnippet}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {sortedItems.length === 0 && (
              <p className="text-center text-gray-400 mt-8">
                No ingredients found. Try adjusting your search or category.
              </p>
            )}
          </section>
        )}

        {!filterApplied && (
          <div className="text-center py-12">
            <p className="text-gray-400 text-lg">
              Select a category above to explore wholesale ingredients tailored
              for women entrepreneurs in MahilaMandi Udyog.
            </p>
          </div>
        )}

        {/* Supplier Modal */}
        {showSupplierDetails && (
          <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
            <div className="bg-gray-800 p-6 rounded-lg max-w-md w-full mx-4">
              <h3 className="text-lg font-bold mb-4">Supplier Details</h3>
              <p className="mb-2">
                <strong>Name:</strong> {showSupplierDetails.name}
              </p>
              <p className="mb-2">
                <strong>Location:</strong> {showSupplierDetails.location}
              </p>
              <div className="flex items-center mb-2">
                <strong>Rating:</strong>
                <span className="ml-2">
                  {renderStars(showSupplierDetails.rating)}
                </span>
                <span className="ml-1">
                  ({showSupplierDetails.numReviews} reviews)
                </span>
              </div>
              <p className="italic text-sm text-gray-300 mb-4">
                "{showSupplierDetails.reviewSnippet}"
              </p>

              <p className="flex items-center mb-2">
                <FontAwesomeIcon icon={faPhone} className="mr-2" />
                <a
                  href={`tel:${showSupplierDetails.phone}`}
                  className="hover:underline"
                >
                  {showSupplierDetails.phone}
                </a>
              </p>
              <p className="flex items-center mb-4">
                <FontAwesomeIcon icon={faEnvelope} className="mr-2" />
                <a
                  href={`mailto:${showSupplierDetails.email}`}
                  className="hover:underline"
                >
                  {showSupplierDetails.email}
                </a>
              </p>
              <button
                onClick={handleHideSupplier}
                className="w-full bg-red-600 hover:bg-red-700 text-white py-2 rounded-md"
              >
                Close
              </button>
            </div>
          </div>
        )}
      </main>

      {/* Footer */}
      <footer className="bg-green-900 p-4 text-center text-sm text-gray-300">
        <p>
          &copy; 2025 MahilaMandi Wholesale Supply - Empowering Women Udyog
          Enterprises
        </p>
        <p className="mt-1">
          Bulk raw materials for supply chain, manufacturing, and scaling
          women-led enterprises.
        </p>
      </footer>
    </div>
  );
}
